import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./AdminShared.css";
import { API_BASE_URL } from "../config";

const AdminCertificate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    const adminInfo = localStorage.getItem("adminInfo");
    if (!adminInfo) return navigate("/admin");
  }, [navigate]);

  const fetchCertificates = useCallback(async () => {
    try {
      setLoading(true);
      const adminInfo = JSON.parse(localStorage.getItem("adminInfo") || "null");
      const token = adminInfo?.token;
      
      if (!token) return;

      const res = await fetch(`${API_BASE_URL}/api/certificates`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Failed to fetch certificates");
      const data = await res.json();
      setCertificates(data.reverse());
    } catch (error) {
      console.error("Error fetching certificates:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCertificates();
  }, [fetchCertificates, location.search]);

  const handleDelete = async (id) => {
    if (window.confirm("Confirm deletion of this operational certificate?")) {
      try {
        const token = JSON.parse(localStorage.getItem("adminInfo"))?.token;
        await fetch(`${API_BASE_URL}/api/certificates/${id}`, {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        });
        fetchCertificates();
      } catch (error) {
        console.error("Error deleting certificate:", error);
      }
    }
  };


  if (loading && certificates.length === 0) return (
    <div className="admin-list-container">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '80vh', gap: '20px' }}>
            <div className="loading-spinner"></div>
            <p style={{ fontWeight: 700, color: '#475569' }}>⏳ Syncing Certification Registry...</p>
        </div>
    </div>
  );

  const filteredCertificates = certificates.filter((c) =>
    (c?.name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="admin-list-container">
      <div className="admin-list-content">
        <div className="page-title-section">
          <h1>Resource Management</h1>
          <p>Authorize and manage issued digital credentials.</p>
        </div>
        <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: '#d946ef' }}></div>
            Operator: Sanjay
          </div>
          <div className="admin-controls">
            <div className="admin-search-wrapper">
              <span className="search-icon-fixed">🔍</span>
              <input
                type="text"
                placeholder="Filter decentralized certification data..."
                className="admin-search-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>

        <ul className="admin-data-list">
          {filteredCertificates.map((item, idx) => (
            <li key={item._id} className="admin-data-item">
              <div className="item-name-box">
                <div className="item-index-circle">{idx + 1}</div>
                <span className="item-name-text">{item?.name || "Unlabeled Certification"}</span>
              </div>
              <div className="item-actions">
                <button
                  className="action-btn-elite btn-update"
                  onClick={() => navigate(`/admin/editcertificate/${item._id}`)}
                >
                  <span>✏️</span> Update
                </button>
                <button
                  className="action-btn-elite btn-delete"
                  onClick={() => handleDelete(item._id)}
                >
                  <span>🗑️</span>
                </button>
              </div>
            </li>
          ))}
          
          {filteredCertificates.length === 0 && (
            <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}>
              <p>No matching certifications found in the secure database.</p>
            </div>
          )}
        </ul>

        <button 
          className="admin-fab-add" 
          onClick={() => navigate("/admin/add-certificate")}
          title="Initialize New Certification"
          style={{ background: '#d946ef', boxShadow: '0 10px 30px rgba(217, 70, 239, 0.4)' }}
        >
          ＋
        </button>
      </div>
    </div>
  );
};

export default AdminCertificate;
